import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import Modal from "@mui/material/Modal";
import "./CreateJobPost.css";
import { Select } from "antd";
import "antd/dist/antd.css";
import {
  createJobPost,
  getJobById,
  updateJobPost,
} from "../../../APIs/PostAPIS";
import CreateNewJObModal from "../../Common/CreateJobModal/NewJobModal";
import "../../Common/CreateJobCard/create-new-job-card.style.scss";

import { Data } from "../../../StaticData/Data";

const { Option } = Select;

// function handleChange(value) {
//   console.log(`selected ${value}`);
// }

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));
const marks = [
  {
    value: 0,
    scaledValue: 100000,
    label: "1Lac",
  },
  {
    value: 25,
    scaledValue: 250000,
    label: "2.5Lac",
  },
  {
    value: 50,
    scaledValue: 500000,
    label: "5Lac",
  },
  {
    value: 75,
    scaledValue: 750000,
    label: "7.5Lac",
  },
  {
    value: 100,
    scaledValue: 1000000,
    label: "10Lac",
  },
];

function valuetext(value) {
  return `${value}`;
}
const CreateJobPost = ({ disableInitial }) => {
  const [input, setInput] = useState(1);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  useEffect(() => {
    disableInitial(false);
  }, []);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    // border: "2px solid #000",
    // boxShadow: 24,
    p: 4,
  };

  // added by uzhairkhan
  // add job post
  const history = useHistory();
  const [jobData, setJobData] = useState({
    job_id: "",
    job_title: "",
    job_curiculum: "",
    job_role: "",
    job_class: "",
    job_subject: "",
    job_experience: "",
    job_type: "",
    job_vacancies: "",
    job_salary_range: "",
    job_key_skill: [],
    job_description: "",
    isDraft: false,
    job_gender_preference: "",
    job_outstation_candidate: "",
    job_martinal_status: "",
    job_perk_provided: [],
    job_language_preference: [],
    job_college_preference: [],
    institution_logo: false,
    institution_name: false,
    institute_location: false,
    about_institution: false,
    salary: false,
    job_publish_status: false,
    bed_required: "",
    min_qualifications: "",
    position_reports_to: "",
  });
  const search = useLocation().search;
  const id = new URLSearchParams(search).get("id");

  const [vacancies, setVacancies] = useState(0);
  const [salaryRange, setSalaryRange] = useState([0, 25]);

  const [openBasicModal, setOpenBasicModal] = useState(false);
  console.log(Data);
  const increment = () => {
    setVacancies((prevState) => prevState + 1);
  };

  const decrement = () => {
    setVacancies((prevState) => {
      if (prevState) {
        return prevState - 1;
      } else {
        return 0;
      }
    });
  };

  const handleChange = (e) => {
    setJobData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    (async () => {
      if (id) {
        try {
          let resp = await getJobById(id);
          if (resp.data.statusCode === 200) {
            const jobData = resp.data.data;
            console.log(jobData);
            setJobData({
              job_id: jobData?.job_id ?? "",
              job_title: jobData?.job_title ?? "",
              job_curiculum: jobData?.job_curiculum ?? "",
              job_role: jobData?.job_role ?? "",
              job_class: jobData?.job_class ?? "",
              job_subject: jobData?.job_subject ?? "",
              job_experience: jobData?.job_experience ?? "",
              job_type: jobData?.job_type ?? "",
              job_vacancies: jobData?.job_vacancies ?? "",
              job_salary_range: jobData?.job_salary_range ?? "",
              job_key_skill: jobData?.job_key_skill ?? [],
              job_description: jobData?.job_description ?? "",
              isDraft: jobData?.isDraft ?? false,
              job_gender_preference: jobData?.job_gender_preference ?? "",
              job_outstation_candidate: jobData?.job_outstation_candidate ?? "",
              job_martinal_status: jobData?.job_martinal_status ?? "",
              job_perk_provided: jobData?.job_perk_provided ?? [],
              job_language_preference: jobData?.job_language_preference ?? [],
              job_college_preference: jobData?.job_college_preference ?? [],
              institution_logo: jobData?.institution_logo ?? false,
              institution_name: jobData?.institution_name ?? false,
              institute_location: jobData?.institute_location ?? false,
              about_institution: jobData?.about_institution ?? false,
              salary: jobData?.salary ?? false,
              job_publish_status: jobData?.job_publish_status ?? false,
              bed_required: jobData?.bed_required ?? "",
              min_qualifications: jobData?.min_qualifications ?? "",
              position_reports_to: jobData?.position_reports_to ?? "",
            });
            setVacancies(JSON.parse(jobData.job_vacancies));
            const salary = JSON.parse(jobData.job_salary_range);
            let value_1 = salary[0];
            let value_2 = salary[1];
            let value = marks
              .filter(
                (s) => s.scaledValue === value_1 || s.scaledValue === value_2
              )
              .map((v) => v.value);
            console.log("salary", value);
            setSalaryRange(value.length ? value : [0, 25]);
          }
        } catch (err) {
          console.log(err.response);
        }
      } else {
        setJobData({
          job_id: "",
          job_title: "",
          job_curiculum: "",
          job_role: "",
          job_class: "",
          job_subject: "",
          job_experience: "",
          job_type: "",
          job_vacancies: "",
          job_salary_range: "",
          job_key_skill: [],
          job_description: "",
          isDraft: false,
          job_gender_preference: "",
          job_outstation_candidate: "",
          job_martinal_status: "",
          job_perk_provided: [],
          job_language_preference: [],
          job_college_preference: [],
          institution_logo: false,
          institution_name: false,
          institute_location: false,
          about_institution: false,
          salary: false,
          job_publish_status: false,
          bed_required: "",
          min_qualifications: "",
          position_reports_to: "",
        });
        setVacancies(0);
      }
    })();
    return () => {};
  }, [id, search]);

  useEffect(() => {
    console.log("jobData", jobData);
    return () => {};
  }, [jobData]);

  useEffect(() => {
    setJobData((prevState) => ({
      ...prevState,
      job_vacancies: JSON.stringify(vacancies),
    }));
    return () => {};
  }, [vacancies]);

  // when adding salary
  useEffect(() => {
    let value_1 = salaryRange[0];
    let value_2 = salaryRange[1];
    let value = marks
      .filter((s) => s.value === value_1 || s.value === value_2)
      .map((v) => v.scaledValue);
    // console.log(value);
    setJobData((prevState) => ({
      ...prevState,
      job_salary_range: JSON.stringify(value),
    }));
    return () => {};
  }, [salaryRange]);

  const handlePerks = (e, val) => {
    const perksArray = jobData.job_perk_provided;
    if (e.target.checked) {
      if (!perksArray.includes(val)) {
        perksArray.push(val);
        setJobData((prevState) => ({
          ...prevState,
          job_perk_provided: perksArray,
        }));
      }
    } else {
      if (perksArray.includes(val)) {
        perksArray.splice(perksArray.indexOf(val), 1);
        setJobData((prevState) => ({
          ...prevState,
          job_perk_provided: perksArray,
        }));
      }
    }
  };

  const addJobPost = async () => {
    try {
      let resp = await createJobPost(jobData);
      console.log(resp);
      if (resp.data.statusCode === 200) {
        history.push(`/institute/job/createjobpost/cart?id=${id}`);
      }
    } catch (err) {
      console.log(err.response);
    }
  };
  const updateJob = async () => {
    try {
      let resp = await updateJobPost(id, jobData);
      console.log(resp);
      if (resp.data.statusCode === 200) {
        history.push(`/institute/job/createjobpost/cart?id=${id}`);
      }
    } catch (err) {
      console.log(err.response);
    }
  };

  // added by uzhairkhan

  return (
    <>
      <div className="jobPost-container">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Text in a modal
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
            </Typography>
          </Box>
        </Modal>
        <header className="jpdm-routes">
          <Link to="/institute/jobs-list">Job List</Link>
          <span>{">"}</span>

          <p>Create Job Post </p>
        </header>
        {/* <div className="title">Job List {">"} Create Job Post</div> */}
        <div className="job-detials">
          <div className="job-detials-title">
            <div className="job-title">Create Job Post</div>
            <div className="job-title-buttons">
              <Button
                variant="outlined"
                className="import-btn"
                onClick={() => setOpenBasicModal(!openBasicModal)}
              >
                Import Similar Job
              </Button>
              <Button
                variant="contained"
                className="save-draft"
                style={{ color: "white" }}
                onClick={() => {
                  setJobData((prevState) => ({
                    ...prevState,
                    isDraft: true,
                  }));
                }}
              >
                Save as draft
              </Button>
            </div>
          </div>
          <div className="inp-container">
            <div className="sub-title">
              <div className="sub-title-num"> 01</div>
              <div className="sub-title-title1">JOB DETAILS</div>
            </div>
            <TextField
              id="outlined-multiline-flexible"
              label="Job Title"
              multiline
              maxRows={4}
              // defaultValue={"Maths Teacher"}
              name="job_title"
              value={jobData.job_title}
              onChange={handleChange}
              className="job-detials-input-inp1"
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Curriculum"
              name="job_curiculum"
              value={jobData.job_curiculum}
              onChange={handleChange}
              // onChange={(e) => setInput(e.target.value)}
              className="job-detials-input-inp2"
            >
              {Data
                ? Data.curriculum.map((r) => (
                    <MenuItem value={r.value} key={r.id}>
                      {r.label}
                    </MenuItem>
                  ))
                : ""}
              {/* <MenuItem value="cbse">CBSE</MenuItem>
              <MenuItem value="matric">MATRIC</MenuItem> */}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Role"
              name="job_role"
              value={jobData.job_role}
              onChange={handleChange}
              // onChange={(e) => setInput(e.target.value)}
              className="job-detials-input-inp3"
            >
              {Data
                ? Data.role.map((r) => (
                    <MenuItem value={r.value} key={r.id}>
                      {r.label}
                    </MenuItem>
                  ))
                : ""}
              {/* <MenuItem value="student">Student</MenuItem> */}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Class"
              name="job_class"
              value={jobData.job_class}
              onChange={handleChange}
              className="job-detials-input-inp4"
            >
              {Data
                ? Data.class.map((r) => (
                    <MenuItem value={r.value} key={r.id}>
                      {r.label}
                    </MenuItem>
                  ))
                : ""}
              {/* <MenuItem value="class 8-10">Class 8-10</MenuItem>
              <MenuItem value="class 11-12">Class 11-12</MenuItem> */}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Subjects"
              name="job_subject"
              value={jobData.job_subject}
              onChange={handleChange}
              className="job-detials-input-inp5"
            >
              {Data
                ? Data.subjects.map((r) => (
                    <MenuItem value={r.value} key={r.id}>
                      {r.label}
                    </MenuItem>
                  ))
                : ""}
              {/* <MenuItem value="maths">Maths</MenuItem>
              <MenuItem value="english">English </MenuItem> */}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Experience"
              name="job_experience"
              value={jobData.job_experience}
              onChange={handleChange}
              className="job-detials-input-inp6"
            >
              {Data
                ? Data.exp.map((r) => (
                    <MenuItem value={r.value} key={r.id}>
                      {r.label}
                    </MenuItem>
                  ))
                : ""}
              {/* <MenuItem value="4-6yrs">4-6 years</MenuItem>
              <MenuItem value="6-10yrs">6-10 years </MenuItem> */}
            </TextField>
            <FormControl
              component="fieldset"
              className="job-detials-input-inp7"
            >
              <FormLabel component="legend">Job Type</FormLabel>
              <RadioGroup
                row
                aria-label="gender"
                defaultValue="full-time"
                // name="job_type"
                value={jobData.job_type}
                onChange={handleChange}
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  name="job_type"
                  value="Full Time"
                  control={<Radio />}
                  label="Full Time"
                />
                <FormControlLabel
                  name="job_type"
                  value="Part Time"
                  control={<Radio />}
                  label="Part Time"
                />
              </RadioGroup>
            </FormControl>
            <div className="job-detials-input-inp8">
              <div className="vaccancy-title">No. of Vacancies</div>
              <div className="vaccancy-btn">
                <div className="sub-btn" onClick={decrement}>
                  -
                </div>
                <div className="vaccancy-text">
                  <div className="">{vacancies}</div>
                </div>
                <div className="plus-btn" onClick={increment}></div>
              </div>
            </div>
            <Box className="job-detials-input-inp9">
              <Typography id="non-linear-slider" gutterBottom>
                Salary range
              </Typography>
              <Slider
                style={{ maxWidth: 500 }}
                // track="inverted"
                aria-labelledby="non-linear-slider"
                getAriaValueText={valuetext}
                // defaultValue={[20, 70]}
                max={100}
                valueLabelDisplay="auto"
                step={25}
                value={salaryRange}
                marks={marks}
                onChange={(e, data) => {
                  // console.log(data);
                  setSalaryRange(data);
                }}
              />
              {/* <Typography id="non-linear-slider" gutterBottom>
              Salary Range
            </Typography>
            <Slider
              style={{ maxWidth: 500 }}
              value={salaryRange}
              min={0}
              step={1}
              max={200}
              valueLabelFormat={numFormatter}
              marks={followersMarks}
              scale={scaleValues}
              onChange={handleSalaryChange}
              valueLabelDisplay="auto"
              aria-labelledby="non-linear-slider"
            />
            <Typography>
              Values: {JSON.stringify(scaleValues(salaryRange))}
            </Typography> */}
            </Box>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Position Reports to"
              name="position_reports_to"
              value={jobData.position_reports_to}
              onChange={handleChange}
              className="job-detials-input-inp10"
            >
              <MenuItem value="principal">Principal</MenuItem>
              <MenuItem value="hod">HOD</MenuItem>
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Min Qualification"
              name="min_qualifications"
              value={jobData.min_qualifications}
              onChange={handleChange}
              className="job-detials-input-inp11"
            >
              <MenuItem value="B.Ed">B.Ed</MenuItem>
              <MenuItem value="B.E">B.E</MenuItem>
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="B.Ed Required?"
              name="bed_required"
              value={jobData.bed_required}
              onChange={handleChange}
              className="job-detials-input-inp12"
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No </MenuItem>
            </TextField>
            {/* <TextField
            id="outlined-multiline-flexible"
            label="Key Skills"
            multiline
            // maxRows={4}
            defaultValue={" nikkil"}
            //   onChange={handleChange}
            className="job-detials-input-inp13"
          /> */}
            <div className="job-detials-input-inp13">
              Key Skills
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="select key skill"
                // defaultValue={["Skill 1"]}
                value={jobData.job_key_skill}
                onChange={(e) => {
                  // console.log(e);
                  setJobData((prevState) => ({
                    ...prevState,
                    job_key_skill: e,
                  }));
                }}
                optionLabelProp="label"
              >
                {Data
                  ? Data.key_skills.map((r) => (
                      <Option value={r.value} key={r.id} label={r.label}>
                        <div className="demo-option-label-item">{r.label}</div>
                      </Option>
                    ))
                  : ""}
                {/* <Option value="Skill 1" label="Skill 1">
                  <div className="demo-option-label-item">Skill 1</div>
                </Option>
                <Option value="Skill 2" label="Skill 2">
                  <div className="demo-option-label-item">Skill 2</div>
                </Option>
                <Option value="Skill 3" label="Skill 3">
                  <div className="demo-option-label-item">Skill 3</div>
                </Option>
                <Option value=" Skill 4" label=" Skill 4">
                  <div className="demo-option-label-item">Skill 4</div>
                </Option> */}
              </Select>
            </div>

            <TextField
              id="outlined-multiline-flexible"
              label="Job Description"
              multiline
              maxRows={4}
              name="job_description"
              value={jobData.job_description}
              onChange={handleChange}
              className="job-detials-input-inp14"
            />
            <div className="job-detials-input-inp15" onClick={handleOpen}>
              Choose from Templates
            </div>
          </div>
        </div>
        <div className="preferences">
          <div className="sub-title">
            <div className="sub-title-num"> 02</div>
            <div className="sub-title-title1">PREFERENCE</div>
          </div>
          <div className="preference-grid">
            <TextField
              id="outlined-select-currency-native"
              select
              label="Gender Preference"
              name="job_gender_preference"
              value={jobData.job_gender_preference}
              onChange={handleChange}
              className="preference-grid-inp1"
            >
              <MenuItem value="none">None</MenuItem>
              <MenuItem value="male">Male </MenuItem>
              <MenuItem value="female">Female </MenuItem>
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Outstationed Candidates"
              name="job_outstation_candidate"
              value={jobData.job_outstation_candidate}
              onChange={handleChange}
              className="preference-grid-inp2"
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No </MenuItem>
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Martial Status"
              name="job_martinal_status"
              value={jobData.job_martinal_status}
              onChange={handleChange}
              className="preference-grid-inp3"
            >
              <MenuItem value="unmarried">Unmarried</MenuItem>
              <MenuItem value="married">Married </MenuItem>
            </TextField>
            <div className="preference-grid-inp4">
              <div className="perks">Perks</div>
              <div className="checkbox-perks">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        jobData.job_perk_provided.includes("food")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        handlePerks(e, "food");
                      }}
                    />
                  }
                  label="Food"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        jobData.job_perk_provided.includes("medical-insurance")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        handlePerks(e, "medical-insurance");
                      }}
                    />
                  }
                  label="Medical Insurance"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        jobData.job_perk_provided.includes("accomadation")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        handlePerks(e, "accomadation");
                      }}
                    />
                  }
                  label="Accomodation"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        jobData.job_perk_provided.includes("bonus")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        handlePerks(e, "bonus");
                      }}
                    />
                  }
                  label="Bonus"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        jobData.job_perk_provided.includes("transportation")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        handlePerks(e, "transportation");
                      }}
                    />
                  }
                  label="Transporataion"
                />
              </div>
            </div>
            <div className="preference-grid-inp5">
              Language preference
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="select language"
                // defaultValue={["English"]}
                value={jobData.job_language_preference}
                onChange={(e) => {
                  // console.log(e);
                  setJobData((prevState) => ({
                    ...prevState,
                    job_language_preference: e,
                  }));
                }}
                optionLabelProp="label"
              >
                <Option value="English" label="English">
                  <div className="demo-option-label-item">English</div>
                </Option>
                <Option value="Hindi" label="Hindi">
                  <div className="demo-option-label-item">Hindi</div>
                </Option>
                <Option value="Kannada" label="Kannada">
                  <div className="demo-option-label-item">Kannada</div>
                </Option>
              </Select>
            </div>
            {/* <TextField
            id="outlined-multiline-flexible"
            label="Job Description"
            multiline
            // maxRows={4}
            value={
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit cras elementum odio sed consectetur.  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit cras elementum"
            }
            //   onChange={handleChange}
            className="preference-grid-inp5"
          /> */}
            <div className="preference-grid-inp6">
              Prefered Institutes To Hire From
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="select one institute"
                value={jobData.job_college_preference}
                onChange={(e) => {
                  // console.log(e);
                  setJobData((prevState) => ({
                    ...prevState,
                    job_college_preference: e,
                  }));
                }}
                optionLabelProp="label"
              >
                <Option value="Gera Institute" label="Gera Institute">
                  <div className="demo-option-label-item">Gera Institute</div>
                </Option>
                <Option value="Institute 2" label="Institute 2">
                  <div className="demo-option-label-item">Institute 2</div>
                </Option>
                <Option value="Institute 3" label="Institute 3">
                  <div className="demo-option-label-item">Institute 3</div>
                </Option>
                <Option value=" Institute 4" label=" Institute 4">
                  <div className="demo-option-label-item">Institute 4</div>
                </Option>
              </Select>
            </div>
            {/* <TextField
            id="outlined-multiline-flexible"
            label="Job Description"
            multiline
            // maxRows={4}
            value={
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit cras elementum odio sed consectetur.  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit cras elementum"
            }
            //   onChange={handleChange}
            className="preference-grid-inp6"
          /> */}
            <div className="preference-grid-inp7">
              <div className="detials-title" style={{ marginBottom: "1rem" }}>
                Details need to be hidden from candidates
              </div>
              <div className="detials-on-off-btn">
                <div className="detials-on-off-btn1">
                  <div className="on-off-title">Institute Name & Logo</div>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      // defaultChecked
                      checked={
                        jobData.institution_logo && jobData.institution_name
                      }
                      onChange={(e) => {
                        setJobData((prevState) => ({
                          ...prevState,
                          institution_logo: e.target.checked,
                          institution_name: e.target.checked,
                        }));
                      }}
                      inputProps={{ "aria-label": "ant design" }}
                    />
                  </Stack>
                </div>
                <div className="detials-on-off-btn1">
                  <div className="on-off-title">Institute Location</div>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      // defaultChecked
                      checked={jobData.institute_location}
                      onChange={(e) => {
                        setJobData((prevState) => ({
                          ...prevState,
                          institute_location: e.target.checked,
                        }));
                      }}
                      inputProps={{ "aria-label": "ant design" }}
                    />
                  </Stack>
                </div>
                <div className="detials-on-off-btn2">
                  <div className="on-off-title"> About Institute</div>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      checked={jobData.about_institution}
                      onChange={(e) => {
                        setJobData((prevState) => ({
                          ...prevState,
                          about_institution: e.target.checked,
                        }));
                      }}
                      inputProps={{ "aria-label": "ant design" }}
                    />
                  </Stack>
                </div>
                <div className="detials-on-off-btn3">
                  <div className="on-off-title"> Salary</div>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      checked={jobData.salary}
                      onChange={(e) => {
                        setJobData((prevState) => ({
                          ...prevState,
                          salary: e.target.checked,
                        }));
                      }}
                      inputProps={{ "aria-label": "ant design" }}
                    />
                  </Stack>
                </div>
              </div>
            </div>
            <div className="preference-grid-inp8">
              <div className="job-title-buttons">
                <Button
                  variant="outlined"
                  className="import-btn"
                  onClick={() => {
                    history.push(`/institute/job/createjobpost`);
                  }}
                >
                  Add Another Job
                </Button>
                <Button
                  variant="contained"
                  className="save-draft"
                  style={{ color: "white" }}
                  onClick={id ? updateJob : addJobPost}
                >
                  Publish Job Post
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openBasicModal && (
        <CreateNewJObModal closeIt={() => setOpenBasicModal(false)} />
      )}
    </>
  );
};

export default CreateJobPost;
